import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { DialogContent } from "../errors/DialogContent";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { TextLoca } from "../generic/text/TextLoca";
import { actionLandingPageLogout } from "../landing-page/actionLandingPage";
import { actionReconnectAfterLogin } from "./actionReconnectAfterLogin";
export var _DialogDisconnectedByLogin = function (props) {
    return (React.createElement(DialogWrapper, { onClose: props.onClose, titleLocaId: IdLoca.error_disconnected_title, className: IdStyles.ModalBackground },
        React.createElement("div", { className: "flex flex--guts flex--stacked w100 h100" },
            React.createElement(DialogContent, { messageLocaId: IdLoca.error_disconnected_desc_web })),
        React.createElement("div", { className: "button-ribbon" },
            React.createElement(ButtonPrimary, { onClick: props.onClick },
                React.createElement("div", { className: IdStyles.TextBoldAccent },
                    React.createElement(TextLoca, { id: IdLoca.reconnect }))))));
};
var mapDispatch = function (dispatch) { return ({
    onClick: function () { return dispatch(actionReconnectAfterLogin()); },
    onClose: function () { return dispatch(actionLandingPageLogout()); },
}); };
export var DialogDisconnectedByLogin = connect(undefined, mapDispatch)(_DialogDisconnectedByLogin);



//////////////////
// WEBPACK FOOTER
// ./src/features/reconnect-after-login/DialogDisconnectedByLogin.tsx
// module id = 2896
// module chunks = 3